import { ModuleType } from "@enums/ModuleType";

export class PeriodicNotificationModel {
    id: number;
    name: string;
    active: boolean;
    period: number;
    dayNumber: number;
    moduleType: ModuleType;
    subject: string;
    message: string;
    organizations: number[];
}
